import React, { Component } from "react";
import { connect } from "react-redux";

import { enTokenCMD } from "../../../lib/classTalk/CodeEnum";
import { ctActionType } from "../../../lib/ConstCommand";

import { callEoForSendAction } from "../../../lib/EoBrowserSendUtil";

import {
    teamupOpenToggle,
    toggle_alertModal
} from "../../../modules/chat";

import {
    appendSendMessage,
    appendSendAudioMemo,
    appendSendFileShare,
    emoticonSelectedToggle,
    selectEmoticonSeq,
    emoticonSelectedCancel,
    addFunctionOpenedToggle,
    selectFunctionSeq,
    inkMemoOpenedToggle,
    voiceMemoClosedToggle,
    fileShareToggle,
    fileOpenToggle,
    imgThumbnailClick,
    showQuizResponseInfo,
    showQuizResponseResult,
    quizResponseFinish,
    getDownloadFileList,
    clearDownloadFiles,
    fileDirRemoveToggle,
    openContentSendPanel,
    closeContentSendPanel
} from "../../../modules/classTalk";

import {
    handsupOpenToggle
} from "../../../modules/live";

import {
    getQuizList
} from "../../../modules/quiz";

import {
    openGroupChatPopup,
    openPersonalChat
} from "../../../modules/groupChat";

import CenteredModalInChatting from "../../../components/template/modal/CenteredModalInChatting";
import FileDirRemoveModal from "../../../components/chat/modal/FileDirRemoveModal";
import ClassTalk from "../../../components/chat/ClassTalk";

class ClassTalkContainer extends Component {

    handleSelectedClassTalkFunc = ({ selectedFunc, emoticonSeq, func, msgText, data, filename, fileURL, idx, fileType, memberSeqList, list_member, liveSeq, quizSeq, source, mode, memberSeq }) => {
        const { performChatRoomInfo, userSeq, userNickname } = this.props;

        switch (selectedFunc) {
            // --------------------------- Emoticon --------------------------- //

            case "EMOTICON_TOGGLE":
                this.props.emoticonSelectedToggle();
                break;

            case "EMOTICON_SELECT":
                this.props.selectEmoticonSeq(emoticonSeq);
                break;

            case "EMOTICON_CANCLE":
                this.props.emoticonSelectedCancel();
                break;

            // --------------------------- Send message --------------------------- //

            case "SEND_MSG":
                this.props.appendSendMessage({ msgText, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname, memberSeqList });
                // this.props.appendSendMessage({ msgText, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname }); 
                break;

            case "SEND_VOICE_MEMO":
                this.props.appendSendAudioMemo({ data, url: fileURL, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname, memberSeqList });
                // this.props.appendSendAudioMemo({ selectedFunc, data, url: fileURL, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });
                break;

            // --------------------------- Classtalk func --------------------------- //

            case "FUNC_TOGGLE":
                this.props.addFunctionOpenedToggle();
                break;

            case "FUNC_SELECT":
                this.props.selectFunctionSeq({ func, mode: "hiclass", chatRoomSeq: performChatRoomInfo.chatRoomSeq, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname, memberSeqList });
                // this.props.selectFunctionSeq({ func, mode: "hiclass", chatRoomSeq: performChatRoomInfo.chatRoomSeq, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });

                switch (func) {
                    case ctActionType.GroupChatting:
                        //this.props.openGroupChatPopup({ liveSeq: this.props.activeLive.liveSeq, list_member: this.props.activeLive.list_member });
                        this.props.openGroupChatPopup();
                        break;
                        
                    case ctActionType.InkMemo:
                        // this.props.inkMemoOpenedToggle({ performChatRoomSeq: performChatRoomInfo.chatRoomSeq, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });
                        break;

                    // 여기 이제 안탐.. 안탈걸? 파일공유를 C# 단으로 옮김 ... 20260204 by ykhan
                    case ctActionType.FileShare:
                        let chatRoomSeq = 0;
                        if (performChatRoomInfo.chatRoomSeq !== -1) chatRoomSeq = performChatRoomInfo.chatRoomSeq;
                        this.props.appendSendFileShare({
                            mode: "new-hiclass",
                            chatRoomSeq,
                            data,
                            teacherSeq: userSeq,
                            filename,
                            liveSeq: this.props.activeLive.liveSeq,
                            userSeq,
                            userNickname,
                            command: enTokenCMD.ct_UploadAndShareFiles,
                            memberSeqList,
                            mixedClassStatus: this.props.activeLive.mixedClassStatus
                        });
                        break;

                    case ctActionType.TeamUpWindow:
                        this.props.teamupOpenToggle();
                        break;

                    case ctActionType.HandsUpWindow:
                        this.props.handsupOpenToggle({ userSeq });
                        break;

                    case ctActionType.Quiz:
                        if (!this.props.isQuizWindowOpened) this.props.getQuizList({ userSeq });
                        break;

                    case ctActionType.FileDownload:
                        this.props.getDownloadFileList({ teacherSeq: userSeq, liveSeq: this.props.activeLive.liveSeq });
                        break;

                    case ctActionType.FileClear:
                        this.props.clearDownloadFiles({ teacherSeq: userSeq, liveSeq: this.props.activeLive.liveSeq });
                        break;

                    default:
                        break;
                }
                break;

            case "CLOSE_VOICE_MEMO":
                this.props.voiceMemoClosedToggle();
                break;

            case "INK_MEMO":
                this.props.inkMemoOpenedToggle({ selectedFunc, imgUrl: fileURL, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname /**, performChatRoomSeq: performChatRoomInfo.chatRoomSeq */ });
                break;

            case "PAGE_JPEG":
                this.props.imgThumbnailClick({ imgDataUrl: fileURL, idx });
                break;

            case "FILE_DOWNLOAD":
                this.props.fileShareToggle({ fileURL, originalFileName: filename, idx });
                break;

            case "FILE_OPEN":
                this.props.fileOpenToggle({ fileURL, originalFileName: filename, fileType });
                break;

            case "OPEN_WHISPER":
                this.props.openPersonalChat({ memberSeqList: data.data });
                break;

            case "CALL_EO_FOR_FILE_SHARE":         // 파일 공유 실행 주체를 웹 ---> C# 으로 옮김 ... 260204 by ykhan
                let chatRoomSeq = 0;
                if (performChatRoomInfo.chatRoomSeq !== -1) chatRoomSeq = performChatRoomInfo.chatRoomSeq;    
                this.props.appendSendFileShare({ 
                    mode: "hiclass",
                    chatRoomSeq,
                    teacherSeq: userSeq,
                    liveSeq: this.props.activeLive.liveSeq,
                    userSeq,
                    userNickname,
                    command: enTokenCMD.ct_UploadAndShareFiles,
                    mixedClassStatus: this.props.activeLive.mixedClassStatus
                });
                break;

            // ✅ 신규 추가: 콘텐츠 전송 말풍선 클릭 → 패널 열기
            case "OPEN_CONTENT_SEND_PANEL":
                this.props.openContentSendPanel({
                    msgInfo: data,
                    idx,
                    source: source ? source : "chatting",
                    mode: mode ? mode : "content",
                    memberSeq
                });
                break;

            case "CLOSE_CONTENT_SEND_PANEL":
                this.props.closeContentSendPanel();
                break;

            // --------------------------- Quiz --------------------------- //

            case "SHOW_QUIZ_RESPONSE_INFO":
                this.props.showQuizResponseInfo({ idx });
                break;

            case "QUIZ_RESPONSE_FINISH":
                console.log("idx - ", idx);
                console.log("liveSeq - ", liveSeq);
                console.log("quizSeq - ", quizSeq);
                console.log("userNickname - ", userNickname);
                this.props.quizResponseFinish({ idx, liveSeq, userSeq, userNickname, list_member, quizSeq });
                break;

            case "TOGGLE_FILE_DIR_REMOVE":
                this.props.fileDirRemoveToggle({ isModalOpened: !this.props.isFileDirRemoveModalOpened });
                break;

            default:
                break;
        }
    }

    render() {
        const { classTalkMsg } = this.props;

        return (
            <>
                {
                    this.props.isFileDirRemoveModalOpened &&
                    <CenteredModalInChatting modalClose={this.props.handleSelectedFunc}>
                        <FileDirRemoveModal
                            handleSelectedClassTalkFunc={this.handleSelectedClassTalkFunc}
                        />
                    </CenteredModalInChatting>
                }
                <ClassTalk
                    openInfo={this.props.openInfo}
                    activeLive={this.props.activeLive}
                    classTalkMsg={classTalkMsg}
                    progressCount={this.props.progressCount}
                    isProgressBarShow={this.props.isProgressBarShow}
                    isFileDirRemoveModalOpened={this.props.isFileDirRemoveModalOpened}
                    isFileDownloadingNow={this.props.isFileDownloadingNow}
                    isQuizWindowOpened={this.props.isQuizWindowOpened}
                    isHandsupOpened={this.props.isHandsupOpened}
                    isTeamUpOpened={this.props.isTeamUpOpened}
                    handleSelectedClassTalkFunc={this.handleSelectedClassTalkFunc}
                />
            </>
        );
    }
}

export default connect(
    ({ classTalk, chat, user, live }) => ({
        userSeq                     : user.userSeq,
        userNickname                : user.userNickname,

        whisperMsg                  : classTalk.whisperMsg,

        openInfo                    : {
            isEmoticonSelected      : classTalk.isEmoticonSelected,
            selectedEmoticonSeq     : classTalk.selectedEmoticonSeq,
            isAddFunctionOpened     : classTalk.isAddFunctionOpened,
            isAudioOpened           : classTalk.isAudioOpened,
            audioStatus             : classTalk.audioStatus,
            selectedFunctionSeq     : classTalk.selectedFunctionSeq
        },

        isProgressBarShow           : classTalk.isProgressBarShow,
        progressCount               : classTalk.progressCount,

        classTalkMsg                : classTalk.receivedMsg,
        performChatRoomInfo         : chat.performChatRoomInfo,

        activeLive                  : live.list_live.find(info => info.selectStatus === "Y") !== undefined && 
                                      live.list_live.find(info => info.selectStatus === "Y") !== null ?
                                      live.list_live.find(info => info.selectStatus === "Y") :
                                      {
                                          liveSeq: -1,
                                          liveName: "",
                                          list_member: [],
                                          mixedClassStatus: "N"
                                      },

        isInkMemoOpened             : classTalk.isInkMemoOpened,
        isFileDirRemoveModalOpened  : classTalk.isFileDirRemoveModalOpened,
        isFileDownloadingNow        : classTalk.isFileDownloadingNow,
        isTeamUpOpened              : chat.isOpenedTeamUp,
        isHandsupOpened             : live.isOpenedHandsUp
    }),
    {
        emoticonSelectedToggle,
        emoticonSelectedCancel,
        selectEmoticonSeq,

        addFunctionOpenedToggle,
        selectFunctionSeq,

        appendSendMessage,
        appendSendAudioMemo,
        appendSendFileShare,

        handsupOpenToggle,
        teamupOpenToggle,

        inkMemoOpenedToggle,
        voiceMemoClosedToggle,
        fileShareToggle,
        fileOpenToggle,
        imgThumbnailClick,

        getQuizList,
        showQuizResponseInfo,
        showQuizResponseResult,
        quizResponseFinish,

        getDownloadFileList,
        clearDownloadFiles,
        fileDirRemoveToggle,

        openGroupChatPopup,
        openPersonalChat,

        toggle_alertModal,

        openContentSendPanel,
        closeContentSendPanel
    }
)(ClassTalkContainer);
